import React, { useContext } from 'react';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { dynamoProductQueries } from '../../graphql/queries';
import ProductSection from '../../Components/Store/Products/ProductSection.js';
import StoreSectionContainer from '../../Components/Store/StoreSectionContainer.js';
import GridViewSkeleton from '../../Components/Skeletons/GridViewSkeleton.js';
import { convertLangCodeToGraphqlEnum } from '../../helpers/locale.js';
import { useTranslation } from 'react-i18next';
import { LocaleContext } from '../../Context';

const LatestProducts = () => {
  const { locale } = useContext(LocaleContext);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: productData } = useQuery(dynamoProductQueries.DynamoPromotedProducts, {
    variables: {
      locale: {
        language: convertLangCodeToGraphqlEnum(locale.language),
        currency: locale.currency
      }
    }
  });

  // While the query is in flight, mirror the loaded section: real heading + "view all",
  // with the product row swapped for a grid skeleton so nothing shifts when data lands.
  if (!productData) {
    return (
      <>
        <span id='hands' style={{ position: 'relative', top: -33 }} />
        <StoreSectionContainer
          heading={t('latest-products')}
          ctaButtonLabel='view-all'
          onCtaButtonClick={() => navigate('/products/all')}
          extraWhitespace
        >
          <GridViewSkeleton nowrap />
        </StoreSectionContainer>
      </>
    );
  }

  return (
    <>
      <span id='hands' style={{ position: 'relative', top: -33 }} />
      <ProductSection
        products={productData.dynamoPromotedProducts.products.slice(0, 4)}
        title={t('latest-products')}
        viewAllPath='/products/all'
        extraWhitespace
      />
    </>
  );
};

export default LatestProducts;
